<template>
  <div class="grid flex-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 2xl:grid-cols-6 3xl:grid-cols-7 gap-6 items-start">
    <slot />
  </div>
</template>

<script setup></script>
